import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getToYears } from '@masar/common/utils';
import { MnmFormState } from './mnm-form.state';

export function linkYearRange(
    formState: MnmFormState,
    fromFieldName: string,
    toFieldName: string,
    unsubscribeAll: Observable<unknown>
): void {
    const fromControl = formState.group.controls[fromFieldName];
    const toControl = formState.group.controls[toFieldName];
    const toField = formState.get(toFieldName);

    const applyConstraint = (fromYear: number | null): void => {
        toField.minValue = fromYear ?? undefined;

        const toYear = toControl.value;
        if (fromYear != null && toYear != null && toYear < fromYear) {
            toControl.setValue(null);
        }
    };

    applyConstraint(fromControl.value);

    fromControl.valueChanges
        .pipe(takeUntil(unsubscribeAll))
        .subscribe(fromYear => applyConstraint(fromYear));
}

export function linkYearSelectRange(
    formState: MnmFormState,
    fromFieldName: string,
    toFieldName: string,
    allYears: number[],
    unsubscribeAll: Observable<unknown>
): void {
    const fromControl = formState.group.controls[fromFieldName];
    const toControl = formState.group.controls[toFieldName];
    const toField = formState.get(toFieldName);

    const applyConstraint = (fromYear: number | null): void => {
        toField.items = getToYears(allYears, fromYear);

        const toYear = toControl.value;
        if (fromYear != null && toYear != null && toYear < fromYear) {
            toControl.setValue(null);
        }
    };

    applyConstraint(fromControl.value);

    fromControl.valueChanges
        .pipe(takeUntil(unsubscribeAll))
        .subscribe(fromYear => applyConstraint(fromYear));
}
